import React from 'react';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import styled from 'styled-components';
import logo from '../assets/svg/loop-logo.svg';
import SocialIcon from './SocialIcon';
import PropTypes from 'prop-types';

const Copyright = styled.div`
  font-weight: bold;
  color: #fff;
  font-size: 14px;
  padding: 0.5rem 0;
`;

const StyledCol = styled(Col)`
  line-height: 68px;
`;

const Footer = ({ location, hideSupport }) => (
  <Row>
    <Col className="p-0">
      <Navbar
        bg="dark"
        variant="dark"
        className="pr-0 mt-0 background-color-dark">
        <Container fluid="xl" className="flex-column pt-3">
          <Row className="w-100 py-lg-4 py-md-3">
            <Col className="d-none d-md-block">
              <img src={logo} alt="Loop Energy" />
            </Col>
            <StyledCol className="text-center text-md-right pr-4">
              <SocialIcon
                href="https://www.youtube.com/channel/UCT4bHPtElYlMpgcqPazJyYQ"
                icon="youtube"
              />
              <SocialIcon
                href="https://www.facebook.com/loophomes"
                icon="facebook"
              />
              <SocialIcon href="https://twitter.com/loophomes" icon="twitter" />
            </StyledCol>
          </Row>
          <Row className="w-100 py-lg-4 py-md-3 flex-column-reverse flex-md-row mb-3  mb-md-1">
            <Col sm={12} md={6}>
              <Copyright className="py-2 text-center text-md-left">
                &copy; {new Date().getFullYear()} Loop. All Rights Reserved.
              </Copyright>
            </Col>
            <Col className="pr-0" sm={12} md={6}>
              <Nav
                className="d-flex justify-content-center justify-content-md-end p-0 pr-3"
                activeKey={location.pathname}>
                <Nav.Link href="https://loop.homes/policies/">
                  Policies
                </Nav.Link>
                {hideSupport || (
                  <Nav.Link href="https://kb.loop.homes?utm_source=loop&utm_medium=webapp">
                    Support
                  </Nav.Link>
                )}
              </Nav>
            </Col>
          </Row>
        </Container>
      </Navbar>
    </Col>
  </Row>
);

Footer.propTypes = {
  hideSupport: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default Footer;
